export enum SearchParamsEnum {
  redirectURL = 'redirectURL',
  token = 'token',
  lang = 'lang',
}
